


import { defineComponent, onMounted, ref, onBeforeUnmount, watch, computed, onUnmounted } from 'vue';
import { MessageService } from '../../../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../../../common/infrastructure/servicios/MessageService';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';
import ComponentCommon from '../../../../domain/Functions/ComponentCommon';
import CrudTableTypeConst from '../../../../domain/Constants/CrudTableTypeConst';
import CrudTable from '../../../../../crud/infrastructure/CrudTable.vue'
import { Container } from 'inversify';
import BaseControlTypeConst from '../../../../domain/Constants/BaseControlTypeConst';
import WidgetComponentDataTree from '../../../../../designer/domain/widgetComponent';
import { IapComponentAttribute } from '../../../../../component/domain/iapComponentAttribute';
import { IapCatalogType } from '../../../../../catalog/domain/iapCatalogType';
import HelperCommon from '../../../../../../../common/infrastructure/funciones/HelperCommon';
import ExpressionNomenclatorConst from '../../../../../expression/domain/const/ExpressionNomenclatorConst';
import DataSourceComp from '../../../../../crud/infrastructure/functions/dataSourceComp';
import { clave } from '../../../../../dataupdate/domain/clave';
import DataSourceConst from '../../../../../crud/infrastructure/functions/dataSourceConst';
import DynamicButton from './DynamicButton.vue';
import EventConst from '../../../../../../../common/domain/constantes/EventConst';
import EventBus from '../../../../../../../common/infrastructure/event-bus';
import ComponentUtil from '../../../../../designer/infrastructure/component/util/componentUtil';
import DataSourceUtilComp from '../../../../../crud/infrastructure/functions/dataSourceUtilComp';
import { Dictionary } from '../../../../../expression/domain/dictionary';
import { useStore } from 'vuex';
import { InteractionEvent } from '../../../../../interaction/domain/interactionEvent';
import InteractionConst from '../../../../../interaction/domain/interactionConst';
import { forEachDiagnostic } from '@codemirror/lint';

export default defineComponent({
    name: 'dynamic_crud_tabla',
    components: {
        CrudTable
    },
    props:
    {
        container: {
            type: Object as () => Container
        },
        Component: {
            type: Object as () => WidgetComponentDataTree,
            default: () => ({})
        },
        rootParentId:
        {
            type: Number,
            default: (-1)
        },
        dataSources: {
            type: Object as () => IapComponentDataSource[],
            default: () => ({})
        },
        slotProps: {
            type: Object,
            default: () => ({})
        },
        rootParentAttr: {
            type: Object as () => IapComponentAttribute[],
            default: () => ({})
        },
        customAddNew: {
            type: Boolean,
            default: false
        },

    },
    setup(props, context) {
        //
        const store = useStore();
        const { getTreeFlat } = ComponentUtil();
        const { catalogTypes, vmodel, loaded, getPropertyValue, getPropertyBooleanValue, getPropertyNumberValue, setPropertyValueByName, getProperty, updateDictionary, dictionaryKeys, resolveExpressions, markUnloadComponents, baseOnUnmount, buildMenu, getLayoutComponent, insertData, fieldKey, fieldKeyComponentDataSourceId } = ComponentCommon(props, context,store);
        //const { DELIMITERFIELDS } = DataSourceComp(props.container as any, props, {}, {})
        const DELIMITERFIELDS = "_";
        //const attrsCopy = JSON.parse(JSON.stringify(props.Component.iapComponentAttributes.map(x=> {x.id, x.value})))
        const opNewRegister = ref();
        const menuItems = ref([])
        const layoutMenu = getLayoutComponent(props.Component, CrudTableTypeConst.LAYOUT_ACTIONS_MENU);
        if (layoutMenu && layoutMenu?.children?.length > 0) {
            menuItems.value = buildMenu(layoutMenu?.children[0].children ?? []) as any;
        }

        const slotControls = ref();
        const crudTableControl = ref();

        const clickf = ref(new Function());
        const viewDetail = ref(false);
        const clicktest = () => {
            // eval(' showMessage("click del boton"); alert("hola");')
        }
        const showMessage = (msg: string) => {
            MessageService.showToast(MessageType.Correcto, '', msg)
        }


        const findSelectedRowByKeys = (data: any, keys: clave[]) => {
            const result = Array<Boolean>();
            keys.forEach(k => {
                result.push(data[k.field] === k.value);
            })

            return result.filter(x => x == false) === undefined;

        }

        const updateDictionaryFromRow = (data: any) => {
            const ds = props.Component.iapComponentDataSources.find(x => x !== undefined)
            ds?.dataSource?.iapDataSourceFields?.filter(dsField => dictionaryKeys.includes([ExpressionNomenclatorConst.EXPNOM_DSF, ds.id, dsField.id].join('.'))).forEach(dsField => {
                let _field = '';
                if (dsField.dataSourceTableAliasId == null) {
                    _field = ds.dataSource?.iapDataSourceDataBase?.idBaseDatos + DataSourceConst.DELIMITERFIELDS + DataSourceConst.AGGREGATE_TABLE + DataSourceConst.DELIMITERFIELDS + dsField.field;
                }
                else {
                    _field = ds.dataSource?.iapDataSourceDataBase?.idBaseDatos + DataSourceConst.DELIMITERFIELDS + dsField.tableName + DataSourceConst.DELIMITERFIELDS + dsField.field;
                }
                const _value = data != null ? data[_field] : null;
                updateDictionary([ExpressionNomenclatorConst.EXPNOM_DSF, ds.id, dsField.id].join('.'), _value);

            })

            // se añaden los lk data
            ds?.dataSource?.iapDataSourceFields?.filter(dsField => dsField.dataSourceLookUpId != null).map(x => ({ dataSourceFieldId: x.id, dataSourceLookUpId: x.dataSourceLookUpId, iapDataSourceFields: x.dataSourceLookUp?.dataSource.iapDataSourceFields }))
                //.filter(x =>  dictionaryKeys.includes([ExpressionNomenclatorConst.EXPNOM_DSLK, x.dataSourceLookUpId, ds.id, dsField.id].join('.')))
                .forEach(x => {
                    x.iapDataSourceFields?.filter(dsField => dictionaryKeys.includes([ExpressionNomenclatorConst.EXPNOM_DSLK, x.dataSourceLookUpId, dsField.id].join('.')))
                        .forEach(dsField => {

                            let _field = x.dataSourceFieldId.replaceAll('-', '') + DataSourceConst.DELIMITERFIELDS + dsField.id.replaceAll('-', '');

                            const _value = data != null ? data[_field] : null;
                            updateDictionary([ExpressionNomenclatorConst.EXPNOM_DSLK, x.dataSourceLookUpId, dsField.id].join('.'), _value);

                        })
                })
                
                if (ds?.dataSource){
                    ds.dataSource.items = data != null ? [data] : null;
                }
        }
        const updateSelectedRow = (data: any, _viewDetail: boolean = true) => {
            if (data?.keys?.length > 0) {
                setPropertyValueByName(CrudTableTypeConst.SELECTEDROW, data.keys)
                updateDictionaryFromRow(data?.item)

            }
            else {
                setPropertyValueByName(CrudTableTypeConst.SELECTEDROW, null)
                updateDictionaryFromRow(null)
            }
            viewDetail.value = _viewDetail;
        }

        const backToList = () => {
            updateSelectedRow(null);
            props.Component?.children?.forEach(child => {
                markUnloadComponents(child);
            })

            // se recargan los datos al volver de ver el detalle del registro seleccionado
            if (crudTableControl.value) {
                crudTableControl.value.doRefreshData();
            }
            viewDetail.value = false;

        }

        const openCustomNew = () => {
            const layoutNew = getLayoutComponent(props.Component, CrudTableTypeConst.LAYOUT_ADDNEW);
            if (layoutNew && layoutNew?.children?.length > 0) {
                const dsToInsert = layoutNew?.children[0]?.iapComponentDataSources.find(x => x !== undefined);
                if (dsToInsert) {
                    if (dsToInsert.iapComponentDataSourceFieldConfigurations.filter(x => x.add == true).length == 0) {
                        MessageService.showMessage(MessageType.Error, "", "El origen de datos no tiene ninguna configuración para añadir registros");
                    }
                    else {
                        const { insertEmptyRowToDataSource } = DataSourceComp(props.container as any, props, {}, {}, dsToInsert, catalogTypes().flatMap(x => x.iapCatalogs), store)
                        insertEmptyRowToDataSource(layoutNew?.children[0].expressions);
                        opNewRegister.value = true
                    }
                }
            }

        }


        const createPromiseValidation = async (compId: number): Promise<InteractionEvent> => {

            return await new Promise<InteractionEvent>((resolve, reject) => {
                var data: Partial<InteractionEvent> = {
                    typeId: InteractionConst.CALL_FUNCTION,
                    objectName: 'isValidData()'

                }
                const keyComponentEventBus = props.rootParentId.toString() + compId.toString() + EventConst.INTERACTION;


                var doCallbackOk = (response: InteractionEvent) => {
                    //console.log('respuesta:' + compId.toString())
                    resolve(response);
                }

                EventBus.emit(keyComponentEventBus, { data: data, callBackResponse: doCallbackOk });


            });


        };





        const saveCustomForm = async () => {

            const layoutNew = getLayoutComponent(props.Component, CrudTableTypeConst.LAYOUT_ADDNEW);
            if (layoutNew && layoutNew?.children?.length > 0) {
                const dsc = getTreeFlat(layoutNew?.children[0], "loaded")


                var promises = new Array();
                let canDo = false;
                //let validate = Array<boolean>();
                dsc.forEach(comp => {

                    promises.push(createPromiseValidation(comp.id));
                });


                /*
                Promise.race(promises).then((responses)=>{
                    console.log('responses');
                    console.log(responses);
                })
                */

                await Promise.all(promises).then((responses: InteractionEvent[]) => {
                    canDo = !(responses.filter(x => !x.interactionResult).length > 0)
                })



                if (canDo) {
                    const dsToInsert = layoutNew?.children[0]?.iapComponentDataSources.find(x => x !== undefined);
                    if (dsToInsert) {

                        if (dsToInsert.iapComponentDataSourceFieldConfigurations.filter(x => x.add == true).length == 0) {
                            MessageService.showMessage(MessageType.Error, "", "El origen de datos no tiene ninguna configuración para añadir registros");
                        }
                        else {
                            insertData(dsToInsert, layoutNew?.children[0].expressions).then(response => {
                                if (response) {
                                    MessageService.showToast(MessageType.Correcto, "", 'Registro creado correctamente.')
                                    // se recargan los datos al volver de ver el detalle del registro seleccionado
                                    if (crudTableControl.value) {
                                        crudTableControl.value.doRefreshData();
                                    }
                                    opNewRegister.value = false
                                }
                            })
                        }

                    }
                }

            }
        }

        const hideCustomNew = () => {
            const layoutNew = getLayoutComponent(props.Component, CrudTableTypeConst.LAYOUT_ADDNEW);
            if (layoutNew && layoutNew?.children?.length > 0) {
                const dsToInsert = layoutNew?.children[0]?.iapComponentDataSources.find(x => x !== undefined);
                if (dsToInsert) {
                    const { clearRowsToDataSource } = DataSourceComp(props.container as any, props, {}, {}, dsToInsert, catalogTypes().flatMap(x => x.iapCatalogs), store)
                    clearRowsToDataSource();
                }
            }

        }


        //const functions = ref([]);
        onMounted(() => {
            // resolveExpressions();  
            //// eval(' showMessage("click del boton"); alert("hola");')
            //alert('hola')
            //clickf.value = new Function('', props.Component.componentAttributes[0].componentAttributeEvent?.code as any);
            //clickf.value = new Function('', eval(' showMessage("click del boton");'))
            //MessageService.showToast(MessageType.Correcto, '', 'Se ha enviado el correo de reestablecimiento de contraseña correctamente.');
            //functions.value.push(f as any)
            //= '';
            //Components
            //clickf.value()
        })

        onUnmounted(() => {
            baseOnUnmount();
            if (getPropertyValue(CrudTableTypeConst.SELECTEDROW)) {
                updateSelectedRow(null);
                props.Component?.children?.forEach(child => {
                    markUnloadComponents(child);
                })
            }

        })


        return {
            clickf,
            MessageService,
            MessageType,
            showMessage,
            clicktest,
            getPropertyValue,
            getPropertyBooleanValue,
            getPropertyNumberValue,
            vmodel,
            CrudTableTypeConst,
            loaded,
            BaseControlTypeConst,
            updateSelectedRow,
            backToList,
            menuItems,
            crudTableControl,
            opNewRegister,
            openCustomNew,
            saveCustomForm,
            slotControls,
            hideCustomNew,
            fieldKey,
            fieldKeyComponentDataSourceId,
            viewDetail
        };
    },
});
